module.exports = __webpack_public_path__ + "img/result_ls_desk.b4618658.jpg";